<div class="terms-and-conditions">
  <div class="terms-and-conditions__wrapper">
    <div class="terms-and-conditions__header">
      <h1>TÉRMINOS Y CONDICIONES</h1>
      <span class="text-gray-green-500">
        Última actualización: 21 de noviembre del 2024
      </span>
    </div>

    <p class="text-paragraph text-gray-green-800">
      Bienvenido a Venta Digital, la plataforma de comercio electrónico de <strong>Proquifa</strong>, diseñada para
      facilitar la compra de
      productos farmacéuticos y químicos. Al registrarse y utilizar esta plataforma, el usuario acepta los siguientes
      Términos
      y Condiciones.
    </p>

    <article class="terms-and-conditions__content">
      <div class="terms-and-conditions__content__item">
        <h4>1. Aceptación de Términos</h4>
        <p>
          Al registrarse en Venta Digital, el usuario acepta estos términos y condiciones, así como nuestra Política de
          Privacidad. Si el usuario no está de acuerdo con alguna de estas condiciones, deberá abstenerse de utilizar el servicio.
        </p>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>2. Registro y Responsabilidad del Usuario</h4>
        <ul>
          <li>
            <p>
              El usuario debe proporcionar información precisa y actualizada al momento de registrarse. Es su responsabilidad mantener
              la confidencialidad de su cuenta y contraseña, y restringir el acceso a su cuenta.
            </p>
          </li>
          <li>
           <p>
            El usuario es responsable de todas las actividades realizadas en su cuenta y de notificar de inmediato cualquier uso no
            autorizado de su cuenta.
           </p>
          </li>
        </ul>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>3. Uso de Información Personal</h4>
        <p>
          <strong>Proquifa</strong> se compromete a proteger la privacidad de los usuarios y a utilizar la información personal conforme a nuestra
          Política de Privacidad. Al registrarse, el usuario autoriza el uso de su información personal para:
        </p>
        <ul class="extra-spacing">
          <li><p>Procesar pedidos y coordinar envíos.</p></li>
          <li>
            <p>
              Enviar comunicaciones relacionadas con productos o servicios de <strong>Proquifa</strong>.
            </p>
          </li>
          <li>
            <p>Realizar análisis internos para mejorar nuestros servicios y ofertas.</p>
          </li>
        </ul>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>4. Condiciones de Compra</h4>
        <ul>
          <li>
            <p>
              Los productos ofrecidos en Venta Digital están sujetos a disponibilidad. <strong>Proquifa</strong> se reserva el derecho de cancelar
              cualquier pedido en caso de falta de stock, notificando al usuario y reembolsando cualquier pago realizado.
            </p>
          </li>
          <li>
            <p>
              Los precios y condiciones de compra pueden ser modificados sin previo aviso. Los precios mostrados incluyen impuestos,
              salvo que se indique lo contrario.
            </p>
          </li>
        </ul>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>5. Envío y Entrega</h4>
        <ul>
          <li>
            <p>
              <strong>Proquifa</strong> se compromete a cumplir con los tiempos de entrega indicados al momento de la compra, aunque estos pueden
              variar por razones fuera de nuestro control.
            </p>
          </li>
          <li>
            <p>
              Los gastos de envío y políticas de entrega serán especificados durante el proceso de compra.
            </p>
          </li>
        </ul>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>6. Política de Devoluciones</h4>
        <ul>
          <li>
            <p>
              Una vez confirmado su pedido a través de este documento, no se aceptarán cambios (cancelaciones y/o modificaciones) ni
              devoluciones.
            </p>
          </li>
          <li>
            <p>
              La tramitación del pedido queda perfeccionada con la confirmación del mismo, conforme a los artículos 80, 88 y
              aplicables del Código de Comercio. Los actos comerciales derivados de esta transacción se regirán bajo la legislación
              mexicana vigente en la Ciudad de México. Cualquier disputa se someterá a la jurisdicción de los Tribunales de la Ciudad
              de México, renunciando expresamente a cualquier otra jurisdicción.
            </p>
          </li>
        </ul>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>7. Derechos de Propiedad Intelectual</h4>
        <p>Todo el contenido, diseño y software de Venta Digital son propiedad exclusiva de <strong>Proquifa</strong> o de sus licenciantes. El uso
        no autorizado de cualquiera de estos elementos está prohibido y será sujeto a las acciones legales correspondientes.</p>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>8. Limitación de Responsabilidad</h4>
        <p>
          <strong>Proquifa</strong> no será responsable por daños indirectos, incidentales o consecuentes derivados del uso de Venta Digital o de
          la imposibilidad de utilizarla.
        </p>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>9. Modificación de los Términos y Condiciones</h4>
        <p>
          <strong>Proquifa</strong> se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento. Las modificaciones serán
          efectivas a partir de su publicación en la plataforma, y el usuario es responsable de revisar periódicamente los
          términos.
        </p>
      </div>

      <div class="terms-and-conditions__content__item">
        <h4>10. Contacto</h4>
        <p>
          Para consultas relacionadas con estos términos y condiciones, el usuario puede contactar a nuestro equipo de atención al
          cliente a través de <a href="mailto:ventas@proquifa.com.mx" class="text-primary-500">ventas&#64;proquifa.com.mx</a> o al teléfono <a href="tel:+525513151498" class="text-primary-500">(55) 1315 1498</a>.
        </p>
      </div>
    </article>
  </div>
</div>
